/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import {
  useCreateCompany,
  useUpdateCompanyMe,
} from "../../../../../api/mutations/company.mutation";
import { useGetCompanyMe } from "../../../../../api/queries/company.query";
import CreateEmpProfileForm from "./create-profile-form";
import { Container } from "react-bootstrap";

function CreateEmpProfile() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    company_name: yup.string().required("Please enter your company name"),
    description: yup
      .string()
      .required("Please enter description for your company"),
    industry: yup.string().required("Please enter your cmpany industry"),
    address: yup.string().required("Please enter your address"),
    website: yup.string().required("Please enter your company website"),
    city: yup.string().required("Please enter your company location"),
    size: yup.string().required("Please enter your company size"),
    number: yup.string().required("Please enter your phone number"),
  });

  const empLoginMutation = useCreateCompany({
    onSuccess: (data) => {},
    onError: (error) => {
      if (error.message) {
        //Handle error msg
      }
    },
    successMessage: "Updated Successfully",
  });

  const onUpdate = (data) => {
    console.log(data);
    empLoginMutation.mutate({
      company_name: data.company_name,
      description: data.description,
      idustry: data.industry,
      address: data.address,
      website: data.website,
      city: data.city,
      size: data.size,
      contact: data.number,
    });
  };

  const initialValues = {
    company_name: "",
    description: "",
    industry: "",
    address: "",
    website: "",
    city: "",
    size: "",
    number: "",
  };

  return (
    <>
      <div id="content-page" className="content-inner">
        <Container className="mt-4 p-4 bg-secondary rounded shadow-sm">
          <Row className="justify-content-center">
            <div
              className="bg-white p-4 rounded shadow-sm w-100"
              style={{ maxWidth: "600px" }}
            >
              <CreateEmpProfileForm />
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default CreateEmpProfile;
